<template>
  <div v-if="data">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <h2 class="text-primary-fh" v-html="data.dashboard.welcomeHeader + fullname"></h2>
          <div class="card dashboard-card">
            <div class="header-wrapper">
              <h2 class="text-primary-fh left-header" v-html="data.dashboardNoReferral.infoHeader"></h2>
            </div>
            <p v-html="data.dashboardNoReferral.infoTextCardio"></p>
          </div>
          <div class="card dashboard-card" v-if="cardioReferral">
            <p class="text-dark">
              <strong>Från vårdgivaren</strong>:
              <br />
              {{ cardioReferral.decisionText || 'Här kommer meddelande från din vårdgivare att visas' }}
            </p>
          </div>
          <div class="card dashboard-card" v-if="!cardioReferral">
            <p class="text-dark text-center">
              <i>Här kommer meddelande från din vårdgivare att visas</i>
            </p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'dashboardcardio',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      fullname: '',
      cardioReferral: null
    }
  },
  methods: {
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    async getCardioDecision () {
      let loader = this.$loading.show({
        opacity: 0.9,
        backgroundColor: '#B5B5B5'
      })
      axios._get(config.gentestUri + config.cardioDecisionUri).then(response => {
        if (response) {
          this.cardioReferral = response.data.cardiologyGeneticTestReferral
          loader.hide()
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get cardio decision regarding genetictest: ' + error)
          loader.hide()
        }
      })
    }
  },
  computed: {},
  async beforeMount () {
    sessionStorage.removeItem('hasVisitedDashboard')
    sessionStorage.setItem('hasVisitedDashboardCardio', 'true')
    this.fullname = sessionStorage.getItem('fullname')
    await this.getCardioDecision()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          dashboard {
            welcomeHeader
          }
          dashboardNoReferral {
            infoTextCardio
            infoHeader
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 125px;
  margin-bottom: 50px;
  min-height: 65vh;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.create-remittance-btn {
  margin-bottom: 1vh;
}
.ul-list {
  border-top: 0;
  text-align: left;
  display: inline-grid;
}
.left-header {
  text-align: left;
}
.text-right {
  display: inline;
  position: absolute;
  top: 0;
  right: 0;
  margin: 1.5em;
}
.margin-left {
  margin-left: 30px;
}
.lab-results-values {
  float: right;
  font-weight: bold;
  font-size: 1.1em;
}
.samplepoints-link span {
  vertical-align: text-top;
}
.dashboard-card {
  padding: 15px 15px 0 15px;
  background: #e5f1f5;
  margin-bottom: 25px;
  border: 2px solid #069ccc;
  border-radius: 15px;
}
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardCardio.vue